import React from "react";
import { Box, Flex, Text, Divider } from "@chakra-ui/react";
import { GoPerson } from "react-icons/go";
import { BrlCurrencyFormatter } from "@/utils/BrlCurrencyFormatter";
import { documentFormatter } from "@/utils/documentFormatter";

type ProposalSummaryProps = {
  releasedAmount: number;
  document: string;
  antecipatedYears: number;
  issueAmount: number;
  monthlyRate: number;
};

const CopyImage = React.forwardRef<HTMLDivElement, ProposalSummaryProps>(
  ({ releasedAmount, antecipatedYears, issueAmount, monthlyRate, document }, ref) => {
    return (
      <Box
        ref={ref}
        bg="white"
        p={4}
        borderRadius="lg"
        boxShadow="md"
        borderColor="gray.200"
        position="relative"
        w="100%"
        minH="300px"
      >
        <Flex justify="space-between" align="center" mb={4}>
          <Flex align="center" ml={4}>
            <GoPerson size="3rem" color="#A0AEC0" />
            <Text fontSize="md" color="gray.500" ml={2} fontFamily="Lexend Deca">
              {documentFormatter(document!)}
            </Text>
          </Flex>
        </Flex>

        <Box ml={4}>
          <Text fontSize="lg" color="blue.600" fontFamily="Lexend Deca">
            O valor liberado será de:
          </Text>
          <Text
            fontSize="4xl"
            fontWeight="bold"
            color="secondary"
            fontFamily="Lexend Deca"
          >
            {BrlCurrencyFormatter(
              releasedAmount
            )}
          </Text>
        </Box>

        <Box ml={4} pt={4}>
          <Text fontSize="md" color="gray.500" fontFamily="Lexend Deca">
            Valor Bloqueado
          </Text>
          <Text
            fontSize="md"
            fontWeight="bold"
            color="blue.600"
            fontFamily="Lexend Deca"
          >
            {BrlCurrencyFormatter(issueAmount!)}
          </Text>
        </Box>

        <Box ml={4} pt={4}>
          <Text fontSize="md" color="gray.500" fontFamily="Lexend Deca">
            Taxa A.M.
          </Text>
          <Text
            fontSize="md"
            fontWeight="bold"
            color="blue.600"
            fontFamily="Lexend Deca"
          >
            {(monthlyRate * 100)?.toFixed(2)}%
          </Text>
        </Box>

        <Box ml={4} pt={4}>
          <Text fontSize="md" color="gray.500" fontFamily="Lexend Deca">
            Anos Antecipados
          </Text>
          <Text
            fontSize="md"
            fontWeight="bold"
            color="blue.600"
            fontFamily="Lexend Deca"
          >
            {antecipatedYears}
          </Text>
        </Box>

        <Divider borderColor="gray.300" mt={4} />
      </Box>
    );
  }
);

export default CopyImage;
